import { SidePanel } from 'components/common-form/sidePanel';
import { DynamicForm } from 'components/dynamicForm/DynamicForm';
import { FormAnalyticsProvider } from 'components/form-analytic-provider';
import { FormTabGuard } from 'components/form-tab-guard';
import { ProductAndClientSelector } from 'components/shared/ProductAndClientSelector/ProductAndClientSelector';
import { useAppSelector } from 'hooks/useAppSelector';
import { useThunkDispatch } from 'hooks/useThunkDispatch';
import { FormIdProps } from 'shared/props';
import { getWorkspaceDynamicTabProductValidation } from 'state/workspaces/dynamic/dynamic.selectors';
import { dynamicWorkspaceTabProductSelectionSubmittedThunk } from 'state/workspaces/dynamic/dynamic.thunks';
export function DynamicMain({ formId }: FormIdProps) {
  const isProductValidated = useAppSelector(state => getWorkspaceDynamicTabProductValidation(state, formId));
  const dispatch = useThunkDispatch();
  if (!isProductValidated) {
    return (
      <ProductAndClientSelector
        workspace="dynamic"
        canSelectClient
        onSubmitted={({ productType, productSubType, wrapper, requestType }, client) =>
          dispatch(
            dynamicWorkspaceTabProductSelectionSubmittedThunk(
              formId,
              productType,
              productSubType,
              wrapper,
              requestType,
              client,
            ),
          )
        }
      />
    );
  }

  return (
    <FormTabGuard formId={formId}>
      <FormAnalyticsProvider name="dynamic form">
        <DynamicForm
          formId={formId}
          hideOpenInBatchWorkspaceButton
          SidePanel={<SidePanel tabId={formId} workspaceType="dynamic" />}
        />
      </FormAnalyticsProvider>
    </FormTabGuard>
  );
}
